import { atom } from 'jotai';

/**
 * Tracks the ID of the quiz currently in edit mode.
 * null means no quiz is being edited.
 *
 * This provides a lightweight way to sync edit state between
 * the quiz card and slider item without causing re-renders.
 * Uses stable quiz IDs instead of indices to prevent stale closure bugs after drag-and-drop.
 */
export const editingQuizIdAtom = atom<string | null>(null);
